import React, { useEffect, useState,useContext } from "react";
import {
  Alert,
  AlertTitle,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Divider,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Backdrop,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UndoIcon from "@mui/icons-material/Undo";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { getMaterialAdjustments, releasePlanning, saveReleaseDraft, clearReleaseDraft ,getusersheduledList, releaseValidation} from "../../utils/GetPlanning";
import { useLocalStorage } from "../../componentUtils/LocalStorage";
import { PlanningState, PlanningItem, MatDetail, ReleaseDraft, DraftLoadType, Summary, ReleaseData, ReleaseDraftData, ClearDraftData } from "./index";
import { getPlanningDynamicList } from "../../utils/GetPlanning";
import { checkForRole } from "../../utils/GetAuth";
import moment from "moment";
import AddMaterials from "./AddMaterials";
import _ from "lodash";
import { SoketContext, DisplayRoleContext } from "../../Context_api";
import { sendTosocket } from "src/utils/GetPubSub";
import { seasonalityHeaderContent } from "src/utils/SeasonalityHelper";

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  table: {},
  cont: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  block: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3),
  },
  addMaterialsActive: {
    color: "#fff !important",
    backgroundColor: "#e9232a !important",
    margin: theme.spacing(3),
  },
  extrasRow: {
    backgroundColor: "#ffa6a6 !important",
  },
}));

interface Inputs {
  setRoutesSelected:any;
  data: PlanningState;
  change: any;
  updateCS: any;
  autoSaveState: any;
  saveAutoSavedState: any;
  bufferValues: any;
  saveReleaseDraftState:any;
  saveReleaseDraftSaveState:any;
  clearDraft:any;
  addSessionCustomer:any
  session:any
  setRefresh:any
  }

interface ReleaseState {
  isLoaded: boolean;
  isSubmitted: boolean;
  data: any;
  summary: Summary[];
  releaseDraft:ReleaseDraft[],
  adjustedSummary: Summary[];
  matDetails: MatDetail[];
  isLoadResetActive: boolean;
}

export interface CustomerData {
  route: string;
  customerNum: string;
  equipmentNum: string;
  predictionList: PredictionData[];
  deliveryType: string;
  customerNotes: any[];
}

export interface PredictionData {
  materialNum: string;
  consignment: number;
  averageSales: number;
  totalEA: number;
  convFactor: number;
}

export interface LoadData {
  materialNum: string;
  loadCS: number;
  convFactor: number;
}

export default function Release(props: Inputs) {
 // console.log("🚀 ~ file: Release.tsx ~ line 117 ~ Release ~ props", props);
  const PM_DYN = "DYNAMIC";
  const PM_STATIC = "STATIC";
  const {broadcast,postmessage ,uuid,is_active,setActive}:any = useContext(SoketContext);
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);
  const [is_disabled, setIsdisabled] = useState(false);
  const classes = useStyles();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [confirm, setConfirm] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [genericAlert, setGenericAlert] = useState<any>({});
  const [showAddMaterials, setShowAddMaterials] = useState(false);
  const [extraMaterials, setExtraMaterials] = useState<any[]>([]);
  const [adjstCases, setAdjstCases] = useState<Map<any, any>>(
    props.autoSaveState && props.autoSaveState.adjstCases ? props.autoSaveState.adjstCases : new Map()
  );
  const [releaseBtndisabled, setReleaseBtndisabled] = useState<boolean>(false);
  const today = new Date().setHours(12, 0, 0, 0);
  const [actDetails, setActDetails] = useState<any[]>([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [state, setState] = useState<ReleaseState>({
    isLoaded: false,
    isSubmitted: false,
    data: [],
    summary: [],
    releaseDraft:[],
    adjustedSummary: [],
    matDetails: [],
    isLoadResetActive: false,
  });
  const [loading, setLoading] = React.useState(false);
  const [releasebackdropLoader, setReleaseBackdropLoader] = useState(false)
  const submitDisabled = !checkForRole(clientId, salesOrg, "vs_submit_schedule");
  const upsertAdjstCases = (key: any, value: any) => {
    setAdjstCases((prev) => new Map(prev).set(key, value));
  };

  const [ updateSaveDraft,setUpdateSaveDaft] = React.useState(false);


  const [sheduledList, setSheduledList] = useState([])
  const [errorRouteMessage, setErrorRouteMessage] = useState({ "validate": true,
  "message":[]});




  useEffect(() => {
  
    setIsdisabled(props.session.is_disable)
  }, [props.session, is_active])


  useEffect(() => {  
    if(updateSaveDraft){
       saveDraft(false,false);
       setUpdateSaveDaft(false);
    }
  }, [updateSaveDraft]);

  useEffect(() => {
    if(is_active){
      setIsdisabled(true)
      }
    props.setRoutesSelected('');
    props.saveAutoSavedState({
      ...props.autoSaveState,
      isLoadResetActive: state.isLoadResetActive,
      adjstCases,
      adjestedMaterials: extraMaterials,
    });
    //console.log(adjstCases);
    if (isLoaded) return;

    const planningDateStr = props.data.planningDate.toISOString().split("T")[0];
      const items = props.data.planningData.filter(
        (elem) => elem.status === "S" && elem.nextDeliveryAct === props.data.planningDate.toISOString().split("T")[0]
      );
      const actDetailsData: any = items.map((a) => a.details); //Object.assign([],actData.map(function(a:any) {return {...a.details};}));
      var actDetailsObj = _.cloneDeep(actDetailsData);
      var summary: Summary[] = [];
      //if (props.data.planMode != PM_DYN) {
        summary = updateSummary(items, props.data.matDetails);
    //  }
      setIsLoaded(true);
      setState({
        isLoaded: true,
        isSubmitted: false,
        data: items,
        summary,
        releaseDraft:[],
        adjustedSummary: summary,
        matDetails: props.data.matDetails,
        isLoadResetActive: props.autoSaveState && props.autoSaveState.isLoadResetActive,
      });
 
      setActDetails([...actDetailsObj]);
      getAdjustmentMaterials();
   // }
  }, [state]);
 // console.log("🚀 ~ file: Release.tsx ~ line 180 ~ Release ~ state", state);

  const revertReleaseInitState = (planningData:PlanningItem[]) => {
    setLoading(true);
    const planningDateStr = props.data.planningDate.toISOString().split("T")[0];
      const items = planningData.filter(
        (elem) => elem.status === "S" && elem.nextDeliveryAct === props.data.planningDate.toISOString().split("T")[0]
      );
      const actDetailsData: any = items.map((a) => a.details); 
      var actDetailsObj = _.cloneDeep(actDetailsData);
      var summary: Summary[] = [];
        summary = updateSummary(items, props.data.matDetails);
      setIsLoaded(true);
      setLoading(false);
      const updatedState ={
        isLoaded: true,
        isSubmitted: false,
        data: items,
        summary,
        adjustedSummary: summary,
        matDetails: props.data.matDetails,
        isLoadResetActive: props.autoSaveState && props.autoSaveState.isLoadResetActive,
      };
      setActDetails([...actDetailsObj]);
      handleAdjustedMaterials(
              extraMaterials,
              updatedState,
              !(props.autoSaveState && props.autoSaveState.isLoadResetActive),
              new Map
            );
  }

  const getAdjustmentMaterials = () => {
    if (!loading) setLoading(true);
    const planningDateStr = props.data.planningDate.toISOString().split("T")[0];
    if (salesOrg && props.data.selectedDeliveryPlant && props.data.selectedRoute && planningDateStr) {
      setTimeout(function() {

      getMaterialAdjustments(salesOrg.toString(), props.data.selectedDeliveryPlant, props.data.selectedRoute, planningDateStr).then(
        (v: any) => {
         // console.log(v);
          if (v && v.matDetails) {
            const extraMats: any = v.matDetails;
            setExtraMaterials(extraMats);
            handleAdjustedMaterials(
              extraMats,
              undefined,
              !(props.autoSaveState && props.autoSaveState.isLoadResetActive)
            );
          }
        }
      );
     }, 1000);
    }
  };

  const handleQtyChange = (event: any,m:any,items:any) => {
    sendTosocket({"salesOrg":salesOrg, message: salesOrg+';'+props.data.selectedDeliveryPlant+';'+props.data.selectedRoute+';'+ props.data.planningDate.toISOString().split("T")[0]+';'+uuid ,event:"is_planning"},salesOrg)
    if(props.data.selectedRoute !=items.routeAct){ 
      return 
    }
    event.persist();
    const identifier = event.target.name.split(";");
    const i = parseInt(identifier[0]);
    const j = parseInt(identifier[1]);

    if (!isNaN(i) && !isNaN(j) && state.data) {
      var planningItems: PlanningItem[] = state.data;
      if(m>=event.target.value){
        planningItems[i].details[j].refill_qty = parseInt(event.target.value) || 0;
      }
      
      var summary: Summary[] = [];
        summary = updateSummary(planningItems, state.matDetails);
      setState({ ...state, data: planningItems, summary });
      const updatedCS=handleAdjustedMaterials(extraMaterials, { ...state, data: planningItems, summary });
        props.saveReleaseDraftSaveState(true,true,updatedCS,{
          planningItems:_.cloneDeep(planningItems[i].details[j]),
          customerNum:planningItems[i].customerNum,
        });
    }
    else{
      props.saveReleaseDraftSaveState(true,false);
    }
    
  };

  const handleSummaryChange = (event: any) => {
    sendTosocket({ "salesOrg":salesOrg,message: salesOrg+';'+props.data.selectedDeliveryPlant+';'+props.data.selectedRoute+';'+ props.data.planningDate.toISOString().split("T")[0]+';'+uuid ,event:"is_planning"},salesOrg)
    event.persist();
    const i = parseInt(event.target.name);

    if (!isNaN(i) && state.adjustedSummary) {
      var summaryItems: Summary[] = [...state.adjustedSummary];
      let newTotalCS = parseInt(event.target.value) || 0;
      let adjstVal = 0;
      if (state.isLoadResetActive) {
        adjstVal = newTotalCS - summaryItems[i].matAdjExtaCS;
      } else {
        adjstVal = newTotalCS - summaryItems[i].totalCS - summaryItems[i].matAdjExtaCS;
      }
      if (newTotalCS < 0) {
        newTotalCS = 0;
      }
      summaryItems[i].adjstCS = adjstVal;
      summaryItems[i].totalReleaseCS = newTotalCS;
      upsertAdjstCases(summaryItems[i].materialNum, adjstVal);
      setState({ ...state, adjustedSummary: summaryItems });
      const hs=updateTotalCS(summaryItems);
      props.saveReleaseDraftSaveState(true,true,hs);
      props.saveAutoSavedState({
        ...props.autoSaveState,
        cases: hs.cases,
        extras: hs.extras,
      });
       saveDraft(false,false);

    }
  };

  const updateTotalCS = (summary: Summary[]) => {
    // update total cases
    var totalCS = 0;
    let totalExtras = 0;
    let actCS = 0
    summary.map((item) => {
      totalCS += item.totalReleaseCS;
      let actExtraCases = item.matAdjExtaCS + item.adjstCS;
      if (actExtraCases <= 0) {
        actExtraCases = 0;
      }
      totalExtras += actExtraCases;
      actCS += item.act_cases 
    });
    props.updateCS({ act_cases: actCS, cases: totalCS, extras: totalExtras });
    return { act_cases: actCS, cases: totalCS, extras: totalExtras };
  };

  const fillConsignment = (i: number, j: number) => {
    if (state.data) {
      sendTosocket({"salesOrg":salesOrg, message: salesOrg+';'+props.data.selectedDeliveryPlant+';'+props.data.selectedRoute+';'+ props.data.planningDate.toISOString().split("T")[0]+';'+uuid ,event:"is_planning"},salesOrg)
      var planningItems: PlanningItem[] = state.data;
      planningItems[i].details[j].refill_qty = planningItems[i].details[j].consignment;
      const summary = updateSummary(planningItems, state.matDetails);
     let updatedCS= handleAdjustedMaterials(extraMaterials, { ...state, data: planningItems, summary });
        props.saveReleaseDraftSaveState(true,true,updatedCS,{
          planningItems:_.cloneDeep(planningItems[i].details[j]),
          customerNum:planningItems[i].customerNum,
        });
      //}
    }

  };

  const restoreRefillQty = (i: number, j: number) => {
    sendTosocket({ "salesOrg":salesOrg, message: salesOrg+';'+props.data.selectedDeliveryPlant+';'+props.data.selectedRoute+';'+ props.data.planningDate.toISOString().split("T")[0]+';'+uuid ,event:"is_planning"},salesOrg)
    if (state.data) {
      var planningItems: PlanningItem[] = state.data;
      planningItems[i].details[j].refill_qty = actDetails[i][j].refill_qty;
      const summary = updateSummary(planningItems, state.matDetails);
      handleAdjustedMaterials(extraMaterials, { ...state, data: planningItems, summary });
    }
  };

  const getBuffer = (matDetails: any, type: string) => {
    const bufferValues = props?.bufferValues;
    const selectedRoute =props.data.selectedRoute;
    const selectedDeliveryPlant=props.data.selectedDeliveryPlant;
    const BUFFER_LEVEL_MATERIAL=3;
    const BUFFER_LEVEL_ROUTE=2;
    const BUFFER_LEVEL_PLANT=1;
    const BUFFER_LEVEL_ALL=0;

    const selMaterialBufferList=bufferValues[matDetails?.material_num_short];
    if(selMaterialBufferList&&selMaterialBufferList?.length > 0){
      let buffer=0;
      let bufferApplied =false;
      for (let index = 0; index < selMaterialBufferList.length; index++) {
        const bufferItem = selMaterialBufferList[index];
        let bufferLevelPriority=0;
        if(bufferItem?.deliveryPlant === selectedDeliveryPlant){
          if(bufferItem?.route === selectedRoute){
              if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
                buffer = type === 'online' ? bufferItem?.onlineBuffer : bufferItem?.offlineBuffer;
                bufferLevelPriority=BUFFER_LEVEL_ROUTE;
                bufferApplied=true;
              }
            }else if (bufferItem?.route =="All") {
              if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
                buffer = type === 'online' ? bufferItem?.onlineBuffer : bufferItem?.offlineBuffer;
                bufferLevelPriority=BUFFER_LEVEL_PLANT;
                bufferApplied=true;
              }
            }
        }
      }
      if(bufferApplied){
        return buffer;
      }
    }
    if(bufferValues?.All){
      const allVal = bufferValues?.All
      let buffer=0;
      let bufferLevelPriority=0;

      for (let index = 0; index < allVal.length; index++) {
        const item = allVal[index];
        if(item?.deliveryPlant === selectedDeliveryPlant){
          if(item?.route === selectedRoute){
            if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ROUTE;
            }
          }else if (item?.route =="All") {
            if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_PLANT;
            }
          }
        }else if(item?.deliveryPlant === 'All'){
          if(item?.route === selectedRoute){
            if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ROUTE;
            }
          }else if (item?.route =="All") {
            if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_PLANT;
            }
          }else{
            if(bufferLevelPriority<=BUFFER_LEVEL_ALL){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ALL;
            }
          }
        }
      }
      return buffer
    }
    return 0
  }

  const calculateAdjustedLoad = (matDetails: any) => {
    let res = 0
    const onlineBuffer = getBuffer(matDetails, 'online')
    const offlineBuffer = getBuffer(matDetails, 'offline')
    if(matDetails?.ftcRefilQty){
      res+= matDetails?.ftcRefilQty 
    }
    if(matDetails?.onlineRefilQty){
      res+= (matDetails?.onlineRefilQty) + (matDetails?.onlineRefilQty * (onlineBuffer / 100))
    }
    if(matDetails?.offlineRefilQty){
      res+= (matDetails?.offlineRefilQty) + (matDetails?.offlineRefilQty * (offlineBuffer / 100))
    }
  //console.log('🚀 ~ file: Release.tsx ~ line 320 ~ calculateAdjustedLoad ~ matDetails', matDetails)
  return Math.ceil(res)
  };

  const updateSummary = (items: PlanningItem[], matDetails: MatDetail[]): Summary[] => {
    var summaryMap = new Map<string, number>();
    const bufferMeta: any = {};
    for (var i = 0; i < items.length; i++) {
      const item = items[i];
      for (var j = 0; j < item.details.length; j++) {
        const mat = item.details[j];
        if (item.activity === "NORM" || item.activity === "INIT" || item.equipmentStatus === "NOPH") {
          if (summaryMap.has(mat.material_num)) {
            var totalUnits = summaryMap.get(mat.material_num) || 0;
            totalUnits += mat.refill_qty;
            summaryMap.set(mat.material_num, totalUnits);
            if(item?.ftc){
              let ftcRefillQty = bufferMeta[mat.material_num]?.ftcRefilQty ?? 0
              ftcRefillQty += mat.refill_qty
              bufferMeta[mat.material_num] = {
                ...bufferMeta[mat.material_num],
                ftcRefilQty : ftcRefillQty
              }
            }else if(item?.online){
              let online = bufferMeta[mat.material_num]?.onlineRefilQty ?? 0
              online += mat.refill_qty
              bufferMeta[mat.material_num] = {
                ...bufferMeta[mat.material_num],
                onlineRefilQty : online
              }
            }else{
              let offline = bufferMeta[mat.material_num]?.offlineRefilQty ?? 0
              offline += mat.refill_qty
              bufferMeta[mat.material_num] = {
                ...bufferMeta[mat.material_num],
                offlineRefilQty : offline
              }
            }
            
          } else {
            summaryMap.set(mat.material_num, mat.refill_qty);
            bufferMeta[mat.material_num] = {
              material_num: mat.material_num,
              material_num_short: parseInt(mat.material_num).toString(),
            };
            if(item?.ftc){
              bufferMeta[mat.material_num] = {
                ...bufferMeta[mat.material_num],
                ftcRefilQty : mat.refill_qty
              }
            }else if(item?.online){
              bufferMeta[mat.material_num] = {
                ...bufferMeta[mat.material_num],
                onlineRefilQty : mat.refill_qty
              }
            }else{
              bufferMeta[mat.material_num] = {
                ...bufferMeta[mat.material_num],
                offlineRefilQty : mat.refill_qty
              }
            }
          }
        }
      }
    }
   // console.log("🚀 ~ file: Release.tsx ~ line 282 ~ Release ~ bufferMeta", bufferMeta);

    const matnrs = Array.from(summaryMap.keys());
    var summaryItems = new Array<Summary>();
    for (var i = 0; i < matnrs.length; i++) {
      const matnr = matnrs[i];
      const matDetail = matDetails.find((elem) => elem.materialNum === matnr);
      var matDesc = "";
      const refillQty = summaryMap.get(matnr) || 0;
      const units =  Math.ceil(refillQty);
      const adjusted: number = calculateAdjustedLoad(bufferMeta[matnr]);
      var cs = 0;
      var actcs = 0;
      if (matDetail) {
        matDesc = matDetail.description;
        cs = Math.ceil((adjusted / matDetail.denominator) * matDetail.numerator);
        actcs = Math.ceil((units / matDetail.denominator) * matDetail.numerator);
      }
      if (cs === 0) {
        cs = 1;
        actcs = 1;
      }
      if (cs < 0) {
        cs = 0;
        actcs = 0;
      }
      var summaryItem: Summary = {
        materialNum: matnr,
        description: matDesc,
        totalUnits: refillQty,
        adjustedUnits: adjusted,
        totalCS: cs,
        act_cases: actcs,
        totalReleaseCS: cs,
        matAdjExtaCS: 0,
        adjstCS: 0,
        clearLoad: false,
      };
      summaryItems.push(summaryItem);
      //console.log("🚀 ~ file: Release.tsx ~ line 315 ~ Release ~ summaryItem", summaryItem);
    }
    summaryItems.sort(function (a, b) {
      var textA = a.description?.toUpperCase();
      var textB = b.description?.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    updateTotalCS(summaryItems);
    return summaryItems;
  };

  const getMatConv = (matnr: string): number => {
    var factor = 1;
    const matDetail = props.data.matDetails.find((elem) => elem.materialNum === matnr);
    if (matDetail && matDetail.denominator && matDetail.numerator) {
      factor = matDetail.denominator / matDetail.numerator;
    }
    return factor;
  };

  const submitToBackend = () => {
   // postmessage(`${salesOrg.toString()};${props.data.selectedDeliveryPlant};${props.data.selectedRoute};${new Date(props.data.planningDate).toISOString()?.split("T")[0]};${uuid}`)

    setUpdateSaveDaft(true)
    setReleaseBtndisabled(true)
    setReleaseBackdropLoader(true)
    if ((state.data && state.summary) || (state.data && props.data.planMode === PM_DYN)) {
      // disable submit button
      setState({ ...state, isSubmitted: true });
      // predictive data
      var customerList = new Array<CustomerData>();
      const sourceData: PlanningItem[] = state.data;
      //console.log('🚀 ~ file: Release.tsx ~ line 487 ~ submitToBackend ~ sourceData', sourceData)
      for (var i = 0; i < sourceData.length; i++) {
        const pli = sourceData[i];
        var predictionList = new Array<PredictionData>();
        for (var j = 0; j < pli.details.length; j++) {
          const item = pli.details[j];
          const predictionData: PredictionData = {
            materialNum: item.material_num,
            consignment: item.consignment,
            averageSales: item.average_consumption,
            totalEA: item.refill_qty,
            convFactor: getMatConv(item.material_num),
          };
          predictionList.push(predictionData);
        }
        var deliveryType = "0";
        if (pli.activity === "PREM") {
          deliveryType = "1";
        }
        if (pli.activity === "DISP") {
          deliveryType = "2";
        }
        // equipment is in NOPH already? Don't create ticket and backend flips it back to NORM
        if (pli.equipmentStatus === "NOPH") {
          deliveryType = "0";
        }
        const customerNotes:any = []
        if(pli.customerNotes?.length > 0) {
          const cn = pli.customerNotes
          cn.map((item: any) => {
            const date = new Date(item?.validUntilDt);
            const today = new Date();
            const isValid = date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
            if (!item?.isDeleted && isValid) {
              customerNotes?.push(item);
            }
          });
        }
        
        let filterS=sheduledList.filter((e:any)=>e.customer_num==pli.customerNum)
        
        const customerData: CustomerData = {
          route:pli.routeAct,
          customerNum: pli.customerNum,
          equipmentNum: '',//pli.equipmentNum,
          predictionList:[],
          deliveryType:'',
          customerNotes:[],
        };
        if(filterS.length==0){
        customerList.push(customerData);
      }
      }

      // load data
      var loadList = new Array<LoadData>();
     // if(props.data.planMode===PM_STATIC){
      const summary: Summary[] = state.adjustedSummary;
      for (var n = 0; n < summary.length; n++) {
        const sum = summary[n];
        const loadData: LoadData = {
          materialNum: sum.materialNum,
          loadCS: sum.totalReleaseCS,
          convFactor: getMatConv(sum.materialNum),
        };
        loadList.push(loadData);
      }
   // }

      const releaseData: ReleaseData = {
        plant: props.data.selectedDeliveryPlant,
        route: props.data.selectedRoute,
        loadDate: props.data.planningDate,
        customerList:customerList,
        loadList:[],
    
      };
     // console.log('🚀 ~ file: Release.tsx ~ line 542 ~ submitToBackend ~ releaseData', releaseData)

      //Adding safe check for incorrect data submition
      //props.data.planMode === PM_STATIC &&
      if (
        customerList.filter(function (cus) {
          return cus.route !== props.data.selectedRoute;
        }).length > 0
      ) {
        alert("Mismatch with Route! Please reload and verify data is correct before submit!");
      } else {
        
        let releaseDatass:any ={ selectedRoute:props.data.selectedRoute,
          
          routes:[releaseData]
         } 

        //releaseDatass.routes= [{"route":releaseData.route}]
        releaseValidation(
          salesOrg.toString(),
          props.data.planningDate,
          props.data.selectedDeliveryPlant,
          releaseDatass
         ).then(res=>{
          if(res){
            props.addSessionCustomer(res.culist)
          setErrorRouteMessage({
            validate:res.validate,
            message:res.message
         })
        }
  
         if(res.validate==true){

        releasePlanning(salesOrg.toString(), releaseData, props.data.planMode,uuid).then((v: any) => {
          if (v) {
              if(v?.length>0){
                let responses=':'
                v?.forEach((responces:any,index:number) => {
                  responses+=','+responces.customer
      
                })
               
                setErrorMessage(`Below provided Routes (${props.data.selectedRoute}) are found scheduled from another session, Please reload and verify data is correct before submit!:- ${responses}`);
                return
              }

            setReleaseBtndisabled(false)
            setReleaseBackdropLoader(false)
            if (v.status === "S") {
              props.change();
              props.addSessionCustomer([])
            } else if (v.status === "E") {
              setErrorMessage("Unknown error submitting the route");
              console.error(errorMessage);
            } else if(v.status.charAt(0)==='S'){
              // props.change();
              let customerNums:any = []
              if(v?.colMissDetails){
                v?.colMissDetails?.map((item:any) => {
                  customerNums.push(item?.custNum)
                })
                setErrorMessage('Columns are missing for customers'+ customerNums?.join(','))
              }
            }
             else {
              setErrorMessage(v.toString());
              console.warn(v);
            }
            closeConfirm();
          }
        });

      } })
      }
    }
  };
  const closeConfirm = () => {
    setConfirm(false);
    //setState({...state, isSubmitted: false});
  };

  const showLoading = (isLoading: boolean) => {
    setLoading(isLoading);
  };

  const openConfirm = () => {

      setConfirm(true);
   
  };

  const revertToActuals = () => {
    setAdjstCases(new Map());
    props.saveAutoSavedState({ ...props.autoSaveState, isLoadResetActive: false, adjstCases: new Map(), extraCS: 0 });
    const updatedState = restoreLoadQty();
    handleAdjustedMaterials(extraMaterials, updatedState, true);
  };

  const zeroQuantityStatus = () => {
   // if (props.data.planMode !== PM_DYN) {
      if (state.adjustedSummary.every((summaryObj) => summaryObj.totalReleaseCS === 0)) {
        return true;
      }
   // }
    return false;
  };

  const isDateWithIn = (startDate: any, endDate: any, now: any) => {
    const formattedStartDate = moment(("" + startDate).split("T")[0]).format("YYYY-MM-DD");
    const formattedEndDate = moment(("" + endDate).split("T")[0]).format("YYYY-MM-DD");
    const formattedNowDate = moment(("" + now).split("T")[0]);
    return formattedNowDate.isBetween(formattedStartDate, formattedEndDate, undefined, "[]");
  };

const reloadtoZeroLoadQtyRefresh=(setZero?: any, updatedAdjustedSummary?: any,summaryAct?:any,summaryStates?:any) => {
  const isLoadResetActive = true;
  const summaryObj:any = state.summary&&state.summary.length>0?state.summary:summaryAct;
   const adjustedSummaryObj = setZero ? updatedAdjustedSummary : state.adjustedSummary;
  summaryObj.map(function (x:any) {
    x.totalCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
    let totalReleaseCS = x.matAdjExtaCS + x.adjstCS;
    if (totalReleaseCS < 0) {
      totalReleaseCS = 0;
    }
    //x.totalReleaseCS = x.matAdjExtaCS>0?x.matAdjExtaCS:0;
    //x.totalReleaseCS+=x.adjstCS;
    x.totalReleaseCS = totalReleaseCS;
    //x.act_cases = totalReleaseCS;
    return x;
  });
  adjustedSummaryObj.map(function (x: any) {
    x.totalCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
    let totalReleaseCS = x.matAdjExtaCS + x.adjstCS;
    if (totalReleaseCS < 0) {
      totalReleaseCS = 0;
    }
    //x.totalReleaseCS = x.matAdjExtaCS>0?x.matAdjExtaCS:0;
    //x.totalReleaseCS+=x.adjstCS;
    x.totalReleaseCS = totalReleaseCS;
    //x.act_cases = totalReleaseCS;
    return x;
  });
  setState({ ...state, isLoadResetActive, data:summaryStates.data, summary: summaryObj, adjustedSummary: adjustedSummaryObj });
   updateTotalCS(adjustedSummaryObj);
}

  const handleAdjustedMaterials = (
    adjustedMaterials: any,
    existingState?: any,
    isRestoreZeroAct?: any,
    extraAdjustmentCases?: any
  ) => {
    if (!loading) setLoading(true);
    let updatedCS:any={};
    extraAdjustmentCases = extraAdjustmentCases ? extraAdjustmentCases : adjstCases;
    const updatedState = JSON.parse(JSON.stringify(restoreLoadQty(false)));
    if(updatedState){
    if (adjustedMaterials && adjustedMaterials.length > 0) {
      const summaryState = existingState ? existingState : updatedState;
      const summaryObj: Summary[] = _.cloneDeep(summaryState.summary);
      let newSummary: Summary[] = summaryObj;
      newSummary = summaryObj.map((item: any, row: any) => {
        const summaryItem: Summary = {
          materialNum: item.materialNum,
          description: item.description,
          totalUnits: item.totalUnits,
          adjustedUnits: item.adjustedUnits,
          totalCS: item.totalCS,
          act_cases: item.act_cases < 0 ? 0 : item.act_cases,
          totalReleaseCS: item.totalCS < 0 ? 0 : item.totalCS,
          matAdjExtaCS: 0,
          adjstCS: 0,
          clearLoad: false,
        };
        const adjustedItem = adjustedMaterials.find((mat: any) => item.materialNum === mat.material_num);
        let adjstCSVal = extraAdjustmentCases.get(item.materialNum);
        adjstCSVal = adjstCSVal ? adjstCSVal : 0;
        if (adjustedItem) {
          //if(isDateWithIn(adjustedItem.start_date,adjustedItem.end_date,props.data.planningDate)){
          if (adjustedItem.clear_load) {
            summaryItem.clearLoad = true;
            summaryItem.matAdjExtaCS = 0;
            summaryItem.totalCS = 0;
            summaryItem.act_cases = 0;
            summaryItem.totalReleaseCS = 0;
          } else {
            summaryItem.matAdjExtaCS = adjustedItem.quantity;
            summaryItem.adjstCS = adjstCSVal;
            //const updatedTotalCS =item.totalCS+adjustedItem.quantity;
            //summaryItem.totalCS=updatedTotalCS>=0?updatedTotalCS:0;
            summaryItem.totalCS = item.totalCS;
            summaryItem.act_cases = item.act_cases;
            let releaseCSTotal = item.totalCS + adjstCSVal + adjustedItem.quantity;
            let releaseCSTotalNB = item.totalCS;
            if (releaseCSTotal < 0) {
              releaseCSTotal = 0;
            }
            if (releaseCSTotalNB < 0) {
              releaseCSTotalNB = 0;
            }
            summaryItem.totalReleaseCS = releaseCSTotal;
            summaryItem.act_cases = releaseCSTotalNB;
          }
          //}
        }
        return summaryItem;
      });

      for (const adjustedItem of adjustedMaterials) {
        let adjstCSVal = extraAdjustmentCases.get(adjustedItem.materialNum);
        adjstCSVal = adjstCSVal ? adjstCSVal : 0;
        if (!summaryObj.some((summaryItem) => adjustedItem.material_num === summaryItem.materialNum)) {
          let totalReleaseCS = !adjustedItem.clear_load ? adjustedItem.quantity + adjstCSVal : 0;
          if (totalReleaseCS < 0) {
            totalReleaseCS = 0;
          }
          newSummary.push({
            materialNum: adjustedItem.material_num,
            description: adjustedItem.description.description,
            totalUnits: 0,
            adjustedUnits: 0,
            totalCS: 0,
            act_cases: 0,
            totalReleaseCS,
            matAdjExtaCS: !adjustedItem.clear_load ? adjustedItem.quantity : 0,
            adjstCS: adjstCSVal ? adjstCSVal : 0,
            clearLoad: adjustedItem.clear_load,
          });
        }
      }
      newSummary = handleExtraAdjstCases(newSummary, extraAdjustmentCases);
      setExtraMaterials(adjustedMaterials);
      if (summaryState.isLoadResetActive || (isRestoreZeroAct !== undefined && !isRestoreZeroAct)) {
        reloadtoZeroLoadQty(true, newSummary,summaryObj);
      } else {
        setState({
          isLoaded: true,
          isSubmitted: summaryState.isSubmitted,
          data: summaryState.data,
          summary: summaryObj,
          releaseDraft:[],
          adjustedSummary: newSummary,
          matDetails: summaryState.matDetails,
          isLoadResetActive: summaryState.isLoadResetActive,
        });
      }
      //updateTotalCS(newSummary);
      updatedCS = updateTotalCS(newSummary);
      setShowAddMaterials(false);

    } else {
      // Handle Manual Adjusted Extra Cases
      const summaryState:ReleaseState = existingState ? existingState : updatedState;
      const summaryObj = _.cloneDeep(summaryState.summary);
      let newSummary: Summary[] = summaryObj;
      if (isRestoreZeroAct !== undefined && !isRestoreZeroAct) {
        newSummary = handleExtraAdjstCases(newSummary, extraAdjustmentCases);
       // reloadtoZeroLoadQty(true, newSummary,summaryObj);
        reloadtoZeroLoadQtyRefresh(true, newSummary,summaryObj,summaryState)
      } else {
        newSummary = handleExtraAdjstCases(newSummary, extraAdjustmentCases);
        setState({
          isLoaded: true,
          isSubmitted: summaryState.isSubmitted,
          data: summaryState.data,
          summary: summaryObj,
          releaseDraft:[],
          adjustedSummary: newSummary,
          matDetails: summaryState.matDetails,
          isLoadResetActive: summaryState.isLoadResetActive,
        });
      }
      //const updatedCS = updateTotalCS(newSummary);
      updatedCS = updateTotalCS(newSummary);
      props.saveAutoSavedState({
        ...props.autoSaveState,
        adjestedMaterials: adjustedMaterials,
        cases: updatedCS.cases,
        extras: updatedCS.extras,
      });
    }
  }
    setLoading(false);
    setUpdateSaveDaft(true)
    return updatedCS;
  };

  const handleExtraAdjstCases = (newSummary: any, extraAdjustmentCases: Map<any, any>) => {
    newSummary.map((item: any, row: any) => {
      let adjstCSVal = extraAdjustmentCases.get(item.materialNum);
      adjstCSVal = adjstCSVal ? adjstCSVal : 0;
      item.adjstCS = adjstCSVal;
      let releaseTotalCS = item.totalCS + adjstCSVal + item.matAdjExtaCS;
      if (releaseTotalCS < 0) {
        releaseTotalCS = 0;
      }
      item.totalReleaseCS = releaseTotalCS;
      // item.act_cases = releaseTotalCS;
      return item;
    });
    return newSummary;
  };

  const handleAddMaterialsSave = () => {
    setLoading(true);
   // console.log("Add Materials Pop");
    getAdjustmentMaterials();
    setShowAddMaterials(false);
  
  };

  const saveDraft = (isSaveDraftRelease:boolean=true,is_zeroLoad:boolean=false) => {
    
   // console.log("Clicked Save as Draft") ;
    const truckLoadState:ReleaseDraft[]=[];
    const customerLoadState:ReleaseDraft[]=[]; 
    const summary: Summary[] = state.adjustedSummary;
    const planningItems: PlanningItem[]=state.data;
    summary.forEach(summaryItem => {
      const draftItem: ReleaseDraft = {
        sales_org: salesOrg,
        sales_office: props.data.selectedDeliveryPlant,
        delivering_plant: props.data.selectedDeliveryPlant,
        route: props.data.selectedRoute,
        load_date: props.data.planningDate,
        customer_num: '' ,
        equipment_num: '',
        ftc: false,
        online:false,
        zeroload:is_zeroLoad?true:state.isLoadResetActive,//state.isLoadResetActive,
        draft_load_type: DraftLoadType.TRUCKLOAD,
        material_num: summaryItem.materialNum,
        qty:summaryItem.totalUnits,
        bfr_adj_qty:summaryItem.adjustedUnits,
        adj_cs:summaryItem.matAdjExtaCS,
        extra_cs:summaryItem.adjstCS,
        clear_load:summaryItem.clearLoad,
        total_cs:summaryItem.totalReleaseCS,
        consignment:0,
        average_consumption:0,
        refill_quantity:0,
        delivery_type:0,
        conv_factor:getMatConv(summaryItem.materialNum)
      };
      truckLoadState.push(draftItem);
    });

    planningItems.forEach(planningItem => {
      var deliveryType = 0;
      if (planningItem.activity === "PREM") {
        deliveryType = 1;
      }
      if (planningItem.activity === "DISP") {
        deliveryType = 2;
      }
      // equipment is in NOPH already? Don't create ticket and backend flips it back to NORM
      if (planningItem.equipmentStatus === "NOPH") {
        deliveryType = 0;
      }

      planningItem.details.forEach(planningItemDetail => {
        const draftItem: ReleaseDraft = {
          sales_org: salesOrg,
          sales_office: props.data.selectedDeliveryPlant,
          delivering_plant: props.data.selectedDeliveryPlant,
          route: props.data.selectedRoute,
          load_date: props.data.planningDate,
          customer_num: planningItem.customerNum ,
          equipment_num: planningItem.equipmentNum,
          ftc: planningItem.ftc,
          online:planningItem.online?true:false,
          zeroload:is_zeroLoad?true:state.isLoadResetActive,//state.isLoadResetActive,
          draft_load_type: DraftLoadType.CUSTOMERLOAD,
          material_num: planningItemDetail.material_num,
          qty:planningItemDetail.refill_qty,
          bfr_adj_qty:0,
          adj_cs:0,
          extra_cs:0,
          clear_load:false,
          total_cs:0,
          consignment:planningItemDetail.consignment,
          average_consumption:planningItemDetail.average_consumption,
          refill_quantity:planningItemDetail.refill_qty,
          delivery_type:deliveryType,
          conv_factor:getMatConv(planningItemDetail.material_num)
        };
        customerLoadState.push(draftItem);
      });
    });

    const releaseDraftData: ReleaseDraftData = {
      salesOrg:salesOrg,
      salesOffice: props.data.selectedDeliveryPlant,
      deliveryPlant: props.data.selectedDeliveryPlant,
      route: props.data.selectedRoute,
      loadDate: props.data.planningDate,
      truckLoadState:truckLoadState,
      customerLoadState:customerLoadState,
    };

    if(props.session.is_disable!=true){
    //send this data to save release draft api
    saveReleaseDraft(salesOrg.toString(),releaseDraftData, props.data.planMode).then((v: any) => {
      if (v) {
        if (v === "S") {
        
          let releaseDraftState:ReleaseDraft[]=truckLoadState.concat(customerLoadState);
          if(isSaveDraftRelease && !is_zeroLoad){
          props.saveReleaseDraftState(releaseDraftState,true); 
        }
          
        } else if (v === "E") {
          setErrorMessage("Unknown error submitting the draft");
          console.error(errorMessage);
        } else {
          setErrorMessage(v);
          console.warn(v);
        }
      }
    });
  }
  
  };

  const clearDraft = () => {

    //console.log("Clicked Clear Draft"); 
   
    const clearDraftData: ClearDraftData = {
      salesOrg:salesOrg,
      plant: props.data.selectedDeliveryPlant,
      route: props.data.selectedRoute,
      loadDate: props.data.planningDate
    }; 
    sendTosocket({"salesOrg":salesOrg, message: salesOrg+';'+props.data.selectedDeliveryPlant+';'+props.data.selectedRoute+';'+ props.data.planningDate.toISOString().split("T")[0]+';'+uuid ,event:"is_planning"},salesOrg)
              const planningDataActual=props.data.planningDataActual;
              props.data.planningData=planningDataActual;
              setAdjstCases(new Map);
              props.clearDraft();
              revertReleaseInitState(planningDataActual);
  };

  const addMaterialsDismiss = () => {
    setShowAddMaterials(false);
  };

  const addMaterials = () => {
    if (salesOrg && props.data.selectedDeliveryPlant && props.data.selectedRoute) {
      setShowAddMaterials(true);
    } else {
      setGenericAlert({ title: "Missing SalesOffice/Route", msg: "Please select SalesOffice and Route to Proceed!" });
    }
  };
  const setZeroLoadQty = (setZero?: any, updatedAdjustedSummary?: any) => {
    sendTosocket({"salesOrg":salesOrg, message: salesOrg+';'+props.data.selectedDeliveryPlant+';'+props.data.selectedRoute+';'+ props.data.planningDate.toISOString().split("T")[0]+';'+uuid ,event:"is_planning"},salesOrg)
    const isLoadResetActive = true;
    const summaryObj = state.summary;
    const adjustedSummaryObj = setZero ? updatedAdjustedSummary : state.adjustedSummary;
    summaryObj.map(function (x) {
      x.totalCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
      x.totalReleaseCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
     // x.act_cases = 0;//x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
      x.adjstCS = 0;
      return x;
    });
    adjustedSummaryObj.map(function (x: any) {
      x.totalCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
      x.totalReleaseCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
      //x.act_cases = 0;//x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
      x.adjstCS = 0;
      return x;
    });
    setState({ ...state, isLoadResetActive, summary: summaryObj, adjustedSummary: adjustedSummaryObj });
    updateTotalCS(adjustedSummaryObj);
  };

  const reloadtoZeroLoadQty = (setZero?: any, updatedAdjustedSummary?: any,summaryAct?:any) => {
    const isLoadResetActive = true;
    const summaryObj:any = state.summary&&state.summary.length>0?state.summary:summaryAct;
    const adjustedSummaryObj = setZero ? updatedAdjustedSummary : state.adjustedSummary;
    summaryObj.map(function (x:any) {
      x.totalCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
      let totalReleaseCS = x.matAdjExtaCS + x.adjstCS;
      if (totalReleaseCS < 0) {
        totalReleaseCS = 0;
      }
      //x.totalReleaseCS = x.matAdjExtaCS>0?x.matAdjExtaCS:0;
      //x.totalReleaseCS+=x.adjstCS;
      x.totalReleaseCS = totalReleaseCS;
      //x.act_cases = totalReleaseCS;
      return x;
    });
    adjustedSummaryObj.map(function (x: any) {
      x.totalCS = x.matAdjExtaCS > 0 ? x.matAdjExtaCS : 0;
      let totalReleaseCS = x.matAdjExtaCS + x.adjstCS;
      if (totalReleaseCS < 0) {
        totalReleaseCS = 0;
      }
      //x.totalReleaseCS = x.matAdjExtaCS>0?x.matAdjExtaCS:0;
      //x.totalReleaseCS+=x.adjstCS;
      x.totalReleaseCS = totalReleaseCS;
      //x.act_cases = totalReleaseCS;
      return x;
    });
    setState({ ...state, isLoadResetActive, summary: summaryObj, adjustedSummary: adjustedSummaryObj });
    updateTotalCS(adjustedSummaryObj);
  };

  const zeroLoadQty = () => {
    if (!state.isLoadResetActive) {
      setZeroLoadQty();
    saveDraft(true,true)
    } else {
      const updatedState = restoreLoadQty(false);
      handleAdjustedMaterials(extraMaterials, updatedState, true, new Map());
      sendTosocket({"salesOrg":salesOrg, message: salesOrg+';'+props.data.selectedDeliveryPlant+';'+props.data.selectedRoute+';'+ props.data.planningDate.toISOString().split("T")[0]+';'+uuid ,event:"is_planning"},salesOrg)
    }
    setAdjstCases(new Map());
  };

  const restoreLoadQty = (saveState = true) => {
    const isResetSummary = false;

    const items = saveState?props.data.planningDataActual.filter(
      (elem) => elem.status === "S" && elem.nextDeliveryAct === props.data.planningDate.toISOString().split("T")[0]
    ):props.data.planningData.filter(
      (elem) => elem.status === "S" && elem.nextDeliveryAct === props.data.planningDate.toISOString().split("T")[0]
    );
    const actDetailsData = items.map((a) => a.details);
    var actDetailsObj = _.cloneDeep(actDetailsData);
    const summary = updateSummary(items, props.data.matDetails);
    const newStateObj={isLoaded: true,isSubmitted: false,data: items,summary:summary,adjustedSummary: summary,matDetails: props.data.matDetails,isLoadResetActive: isResetSummary,
      releaseDraft:[]};
    if (saveState) {
      setState(newStateObj); 
      setActDetails([...actDetailsObj]);
    }

    return newStateObj;
  };

  const setReleaseDynamicDraft = (releaseDraft:ReleaseDraft[],planningdata?:PlanningItem[]) => {
      
    let extraCSSet = new Map<string, number>();
    let isZeroLoadActive =false;
    if(releaseDraft&&releaseDraft.length>0){
    releaseDraft.map(draft => {
      isZeroLoadActive=draft.zeroload;
      if(draft.draft_load_type==DraftLoadType.TRUCKLOAD&&draft.extra_cs!=0){
        extraCSSet.set(draft.material_num,draft.extra_cs);
      }
      if(planningdata&&planningdata.length>0){
      if(draft.draft_load_type==DraftLoadType.CUSTOMERLOAD&&draft.qty){
        const planningItemIndex =planningdata.findIndex(planningItem => planningItem.customerNum === draft.customer_num);
        if(planningItemIndex>=0){
          const planningDetailIndex =planningdata[planningItemIndex].details.findIndex(planningDetailItem => planningDetailItem.material_num === draft.material_num);
          planningdata[planningItemIndex].details[planningDetailIndex].refill_qty = draft.qty;
        }
      }
    }
    });
  }
  return{adjstCases:extraCSSet,planningdata:planningdata,isZeroLoadActive:isZeroLoadActive}
  };

  // if (!state) {
  //   return  <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }} open={true}>
  //   <CircularProgress color="inherit" />
  // </Backdrop>
  // }
//   if (actDetails.length === 0) {
//     return  <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }} open={true}>
// Please
//   </Backdrop>
//   }
  


  return (
    <>  
     {is_disabled?<div className="session-error">{props.session.message}<button onClick={()=> props.setRefresh(true)}> Refresh</button></div>:null}
    
     {actDetails.length==0? <h3 style={{    marginTop: '87px',
    textAlign: 'center'}}> Please schedule a customer to proceed with Adjust and Release  </h3> :(
    <Paper className={classes.cont}>
      <Grid container justifyContent="flex-end">
        {/* <Button className={classes.submit} variant="outlined" color="primary" onClick={() => revertToActuals()}>Revert to Orig</Button> */}
  


            {props.data &&props.data.isRelaseDraftModified&&!props.data.isReleaseDraftSaved? (<Button disabled={is_disabled} className={props.data &&props.data.releaseDraft&&props.data.releaseDraft.length>0 ? classes.addMaterialsActive : classes.submit} variant="outlined" color="primary" onClick={() => saveDraft()}>{"Save Changes"}</Button> ):<></>} 
            {props.data &&props.data.releaseDraft&& props.data.releaseDraft.length>0 ? (<Button  disabled={ isDisplayOnlyRole || is_disabled} className={classes.submit} variant="outlined" color="primary" onClick={() => clearDraft()}>{"Clear Changes"}</Button> ):<></>} 
            {props.data.planMode === PM_STATIC && (
          <div>  <Button disabled={isDisplayOnlyRole || is_disabled}
              className={extraMaterials.length > 0 ? classes.addMaterialsActive : classes.submit}
              variant="outlined"
              color="primary"
              onClick={() => addMaterials()}
            >
              {"Material Adjustments"}
            </Button>
            <Button disabled={isDisplayOnlyRole || is_disabled} className={classes.submit} variant="outlined" color="primary" onClick={() => zeroLoadQty()}>
              {state.isLoadResetActive ? "Restore Load Qty" : "Zero Load Qty"}
            </Button>
          </div>
        )}
        <Button 
          className={classes.submit}
          disabled={isDisplayOnlyRole || zeroQuantityStatus() || is_disabled}
          variant="outlined"
          color="primary"
          onClick={() => openConfirm()}
        >
          SUBMIT
        </Button>
      </Grid>
      {
     // props.data.planMode != PM_DYN && (
        <div className={classes.block}>
          <Divider />
          <Typography variant="h4" className={classes.cont}>
            Truck Load Summary
          </Typography>
          <Divider />
          <TableContainer>
            <Table className={classes.table} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Material</TableCell>
                  <TableCell align="right">Load Qty EA</TableCell>
                  <TableCell align="right">
                    <Typography variant="h6" className={classes.cont}>
                      <Tooltip title="Note: Buffers are added based on the values specified to the respective material or route or salesoffice level "><Typography variant="h6" fontSize="0.875rem">Adjusted Load Qty (*) EA</Typography></Tooltip>
                    </Typography></TableCell>
                 {props.data.planMode != PM_DYN && (<><TableCell align="right">Adjustment CS</TableCell>
                  <TableCell align="right">Extra CS Adjustments</TableCell> </> )}
                  <TableCell align="right">CS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.adjustedSummary.map((summary, j: number) => {
                  const identifier = "" + j;
                  return (
                    <TableRow
                      key={j}
                      className={summary.matAdjExtaCS !== 0 || summary.clearLoad ? classes.extrasRow : ""}
                    >
                      <TableCell component="th" scope="row">
                        {summary.materialNum.replace(/^0+/, "")}: {summary.description}
                      </TableCell>
                      <TableCell align="right">{!summary.clearLoad ? summary.totalUnits : "--"}</TableCell>
                      <TableCell align="right">{!summary.clearLoad ? summary.adjustedUnits : "--"}</TableCell>
                      {props.data.planMode != PM_DYN && (<><TableCell align="right">{summary.matAdjExtaCS}</TableCell>
                      <TableCell align="right">{summary.adjstCS}</TableCell></> )}
                      <TableCell align="right">
                        <TextField
                          color="secondary"
                          label=""
                          value={summary.totalReleaseCS}
                          name={identifier}
                          onChange={handleSummaryChange}
                          disabled={isDisplayOnlyRole || (props.data.planMode != PM_DYN?false:true)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
     // )
      }
      <Divider />

      {state.data.map((item: PlanningItem, i: number) => {
        const seasonalityConent = seasonalityHeaderContent(item?.seasonalityConfig[0], item.selMnthStlmts, item.settlementThreshold);
        return (
          <Accordion className={classes.cont}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} area-control="dexpanel-content" id="dexpanel-header">
              <Typography variant="h6" className={classes.cont}>
                {item.routeAct} / {item.customerNum} / {item.name} / {item.assetNum} / {item.street} {item.location} {
                  (seasonalityConent.text ?
                  <><span style={{fontSize: "17px", fontWeight:"bold"}}>Season: </span><span style={{color: seasonalityConent.textColor, fontSize: "14px", fontWeight:"bold"}}>{`${seasonalityConent.text}, `}</span><span style={{fontSize: "14px",  fontWeight:"bold"}}>{seasonalityConent.nextSeasonality}</span></>
                  :<></>
                  )
                }
                {item.ftc ? (
                  <Tooltip title="Fill To Capacity">
                    <IconButton aria-label="FTC">
                      <AddBoxIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <div />
                )}
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <TableContainer>
                <Table className={classes.table} size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>Material</TableCell>
                      <TableCell align="right">Consignment</TableCell>
                      <TableCell align="right">{seasonalityConent.isSeasonalityApplied  ? "Fill Qty-Seasonality" : "Fill Qty"}</TableCell>
                      <TableCell align="right">CS</TableCell>
                      <TableCell align="right">EA</TableCell>
                    </TableRow>
                    {item.details.map((mat, j: number) => {
                      const matnr = mat.material_num;
                      const matDetail = state.matDetails.find((elem) => elem.materialNum === matnr);
                      var matDesc = matnr.replace(/^0+/, "");
                      var cs = 0;
                      var ea = mat.refill_qty;
                      if (matDetail) {
                        matDesc = matDesc + ": " + matDetail.description;
                        cs = Math.floor((mat.refill_qty / matDetail.denominator) * matDetail.numerator);
                        ea = mat.refill_qty - cs * (matDetail.denominator / matDetail.numerator);
                      }
                      const itemIdent = i + ";" + j;

                     // console.log(itemIdent);
                    //  console.log(actDetails);

                      return (
                        <TableRow key={j}>
                          <TableCell component="th" scope="row">
                            {matDesc}
                          </TableCell>
                          <TableCell align="right">
                            <Button
                              disabled={isDisplayOnlyRole || state.isLoadResetActive}
                              variant="outlined"
                              onClick={() => fillConsignment(i, j)}
                            >
                              {mat.consignment}
                            </Button>
                          </TableCell>
                          <TableCell align="right">
                            <TextField
                              color="secondary"
                              label=""
                              disabled={isDisplayOnlyRole || state.isLoadResetActive}
                              value={mat.refill_qty}
                              name={itemIdent}
                              onChange={e=>{if(!(e.target.value == "" && mat.refill_qty == 0)) handleQtyChange(e,mat.consignment,item)}}
                              InputProps={{
                                endAdornment: (
                                  <IconButton
                                    sx={{
                                      opacity: actDetails&&actDetails[i]&&actDetails[i][j]&&actDetails[i][j].refill_qty&&actDetails[i][j].refill_qty === mat.refill_qty ? [0, 0, 0] : [1, 1, 1],
                                    }}
                                    disabled={isDisplayOnlyRole || (actDetails&&actDetails[i]&&actDetails[i][j]&&actDetails[i][j].refill_qty&&actDetails[i][j].refill_qty === mat.refill_qty)}
                                    onClick={() => restoreRefillQty(i, j)}
                                  >
                                    {<UndoIcon />}
                                  </IconButton>
                                ),
                              }}
                            />
                          </TableCell>
                          <TableCell align="right">{cs}</TableCell>
                          <TableCell align="right">{ea}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        );
      })}

      <Dialog fullWidth={true} maxWidth="md" aria-labelledby="dri-title" open={confirm} onClose={closeConfirm}>
        <DialogTitle id="dri-title">Confirm Activity </DialogTitle>
        <DialogContent>
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }} open={releasebackdropLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
          {props.data.planMode === "STATIC" ? (
            <DialogContentText id="alert-dialog-description">
              Do you want to release route {props.data.selectedRoute}?
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              Do you want to release all routes for {props.data.selectedDeliveryPlant}?
            </DialogContentText>
          )}
       
{
  sheduledList.length>0?<>
<DialogContentText id="alert-dialog-description">
Below provided customers are found scheduled from another session. These will get discarded on Proceeding Release. If you wish to revaluate the schedules again click no and refresh the planning board
            </DialogContentText>
            <div>
            <List  style={{
              "maxHeight": "213px",
              "display": "block",
              "overflowY": "scroll"
            }}>
              {sheduledList.map((item:any,index)=>{
                return(

<ListItem key={index}>
              <div> {item.customer_num}</div>-
              <div> {item.name1} ,{item.name3}</div>

              
                </ListItem>
                )
              })}
                
            </List>
            </div>
            
            </> :''
            }
          

        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeConfirm()} color="primary">
            No
          </Button>
  
          <Button
            disabled={submitDisabled || state.isSubmitted || releaseBtndisabled}
            onClick={() => submitToBackend()}
            color="primary"
            autoFocus
          >
            Yes proceed
          </Button>
        
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorMessage !== undefined}
        onClose={() => {
          setErrorMessage(undefined);
          props.change();
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>Error Releasing Route</AlertTitle>
            <Typography paragraph>{errorMessage}</Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorMessage(undefined);
              props.change();
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={Object.keys(genericAlert).length !== 0}
        onClose={() => {
          setGenericAlert({});
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>{genericAlert && genericAlert.title ? genericAlert.title : ""}</AlertTitle>
            <Typography paragraph>{genericAlert && genericAlert.msg ? genericAlert.msg : ""}</Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setGenericAlert({});
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <AddMaterials
        data={{
          salesOrg,
          plant: props.data.selectedDeliveryPlant,
          route: props.data.selectedRoute,
          planningDate: props.data.planningDate,
          uuid:uuid
        }}
        open={showAddMaterials}
        showLoading={showLoading}
        onSave={handleAddMaterialsSave}
        onClose={addMaterialsDismiss}
      />
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorRouteMessage.validate === false}
        onClose={() => {
          setErrorRouteMessage({ "validate": true,
          "message":[]});
          props.change();
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>Releasing Route Errors</AlertTitle>
            {errorRouteMessage.message.map((res:any)=>{
              return(
                <Typography paragraph>{res.message}</Typography>
              )
            })}
          

          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorRouteMessage({ 
              validate: true,
              message:[]});
              props.change();
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
   
)}
    </>
  );
}
